import * as R from 'ramda';
import { handleActions, combineActions } from 'redux-actions';

import { listToItems } from '../../utils';
import * as commonReducers from './common';
import * as actions from '../actions/organization-settings';

const {
  create,
  update,
  fetch,
  remove,
} = commonReducers.operationTypes;

const fetchOrganizationSettingsSuccessReducer = (state, { payload }) => ({
  ...state,
  [fetch]: false,
  items: {
    requestLabels: listToItems(R.prop('requestLabels', payload)),
    requestSources: listToItems(R.prop('requestSources', payload)),
    requestStatuses: listToItems(R.prop('requestStatuses', payload)),
  },
});

// update / insert settings option
export const upsertSettingsOptionSuccessReducer = (settingsType, operation) =>
  (state, { payload }) => ({
    ...(R.assocPath(['items', settingsType, payload._id], payload, state)),
    [operation]: false,
  });

const deleteSettingsOptionSuccessReducer = settingsType => (state, { payload }) => ({
  ...(R.dissocPath(['items', settingsType, payload._id], state)),
  [remove]: false,
});

export const organizationSettingsReducer = handleActions(
  {
    // fetch
    [actions.fetchOrganizationSettingsRequest]: commonReducers.commonRequestReducer(fetch),
    [actions.fetchOrganizationSettingsFailure]: commonReducers.commonFailureReducer(fetch),
    [actions.fetchOrganizationSettingsSuccess]: fetchOrganizationSettingsSuccessReducer,

    // create
    [combineActions(
      actions.createRequestSourceRequest,
      actions.createRequestStatusRequest,
      actions.createRequestLabelRequest,
    )]: commonReducers.commonRequestReducer(create),

    [combineActions(
      actions.createRequestSourceFailure,
      actions.createRequestStatusFailure,
      actions.createRequestLabelFailure,
    )]: commonReducers.commonFailureReducer(create),

    [actions.createRequestSourceSuccess]: upsertSettingsOptionSuccessReducer('requestSources', create),
    [actions.createRequestStatusSuccess]: upsertSettingsOptionSuccessReducer('requestStatuses', create),
    [actions.createRequestLabelSuccess]: upsertSettingsOptionSuccessReducer('requestLabels', create),

    // update
    [combineActions(
      actions.updateRequestSourceRequest,
      actions.updateRequestStatusRequest,
      actions.updateRequestLabelRequest,
    )]: commonReducers.commonRequestReducer(update),

    [combineActions(
      actions.updateRequestSourceFailure,
      actions.updateRequestStatusFailure,
      actions.updateRequestLabelFailure,
    )]: commonReducers.commonFailureReducer(update),

    [actions.updateRequestSourceSuccess]: upsertSettingsOptionSuccessReducer('requestSources', update),
    [actions.updateRequestStatusSuccess]: upsertSettingsOptionSuccessReducer('requestStatuses', update),
    [actions.updateRequestLabelSuccess]: upsertSettingsOptionSuccessReducer('requestLabels', update),

    // delete
    [combineActions(
      actions.deleteRequestSourceRequest,
      actions.deleteRequestStatusRequest,
      actions.deleteRequestLabelRequest,
    )]: commonReducers.commonRequestReducer(remove),

    [combineActions(
      actions.deleteRequestSourceFailure,
      actions.deleteRequestStatusFailure,
      actions.deleteRequestLabelFailure,
    )]: commonReducers.commonFailureReducer(remove),

    [actions.deleteRequestSourceSuccess]: deleteSettingsOptionSuccessReducer('requestSources'),
    [actions.deleteRequestStatusSuccess]: deleteSettingsOptionSuccessReducer('requestStatuses'),
    [actions.deleteRequestLabelSuccess]: deleteSettingsOptionSuccessReducer('requestLabels'),
  },
  {
    error: null,
    ...commonReducers.defaultState,
  },
);



// WEBPACK FOOTER //
// ./src/redux/reducers/organization-settings.js